/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product bundle.
 */
import { mapMutations, mapGetters } from 'vuex';
import Forms from './../../../../utils/forms/forms';
import productService from './../../../../services/product';
import productBundleService from './../../../../services/productBundle';
import productBundleTransformer from './../../../../transformers/productBundle';
import bulkAddProductModal from './../../../../components/bulkAddProductModal/bulkAddProductModal.vue';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        price: {
          value: '',
          type: 'text',
          attributes: {
            disabled: true,
          },
        },
      }),
      formTable: new Forms({
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            disabled: true,
            href: 'products/_/edit#productInfo',
          },
        },
        price: {
          value: '',
          type: 'text',
        },
        qty: {
          value: '',
          type: 'text',
        },
      }),
      tableData: [],
      groupErrors: [],
    };
  },

  watch: {
    tableData: {
      handler(value) {
        let price = 0;
        value.forEach((p, key) => {
          price += parseFloat(p.price);
          this.tableData[key].price = p.items.reduce((accumulator, object) => accumulator + (parseFloat(object.price) * object.qty), 0);
        });
        this.form.price = price;
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters({
      products: 'basicProducts',
    }),

    isInOwnRoute() {
      return this.$route.name === 'productBundles.create';
    },

    list() {
      return this.tableData;
    },
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalSize: 'SET_MODAL_SIZE',
      setModalProps: 'SET_MODAL_PROPS',
      setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING',
    }),

    numberOnly(e) {
      if (!(/^\d+$/.test(e.key))) {
        e.preventDefault();
      }
    },

    showBulkAddModal() {
      this.setModalContent(() => bulkAddProductModal);
      this.setModalProps({
        fetchProductsMethod: this.fetchAllProductBasic,
        onSave: this.handleBulkSave,
      });
      this.toggleModal(true);
    },

    fetchAllProductBasic() {
      return Promise.all([
        productService.allBasic({
          filter: 'active',
          type: 'product',
        }),
      ]);
    },

    handleBulkSave(selectedProducts) {
      const products = selectedProducts.map(p => ({
        id: p.id,
        name: p.name,
        qty: p.qty,
        taxId: p.taxId,
        price: 0,
        // eslint-disable-next-line comma-dangle
        taxPerc: p.tax_perc
      }));
      return Promise.all([])
      .then(() => {
        products.forEach((item) => {
          const index = this.tableData.findIndex(obj => obj.taxId === item.taxId);
          if (index > -1) {
            this.tableData[index].items.push(item);
          } else {
            this.tableData.push({
              taxPerc: item.taxPerc,
              taxId: item.taxId,
              price: 0,
              items: [item],
            });
          }
        });
      });
    },

    destroyTable(id) {
      return Promise.all([])
      .then(() => {
        this.tableData.forEach((obj, key) => {
          const index = obj.items.findIndex(p => p.id === id);
          if (index > -1) {
            this.tableData[key].items.splice(index, 1);
            if (this.tableData[key].items.length === 0) {
              this.tableData.splice(key, 1);
            }
            return;
          }
        });
      });
    },

    updateTable(id) {
      return Promise.all([])
      .then(() => {
        this.tableData.forEach((obj, key) => {
          const index = obj.items.findIndex(p => p.id === id);
          if (index > -1) {
            this.tableData[key].items[index].qty = this.formTable.qty;
            this.tableData[key].items[index].price = this.formTable.price;
            return;
          }
        });
      });
    },

    store() {
      this.form.loading = true;
      this.groupErrors = [];
      const product = productBundleTransformer.send(this.form.data());
      product.bundles = this.tableData;
      Promise.all([
        productBundleService.store(product),
      ]).then(() => {
        this.form.loading = false;
        this.$router.push({
          name: 'productBundles.index',
        });
      }).catch((errors) => {
        this.form.recordErrors(errors);
        this.form.loading = false;
        this.groupErrors = errors;
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VFormTable: require('./../../../../components/formTable/formTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productBundles/create/create.js